export default {
  getLeadGenQuestions: (state) => {
    return state.leadGenQuestions
  },
  getAnswers: (state) => {
    return state.answers
  },
  getTotalQuestions: (state) => {
    return state.leadGenQuestions?.length || 0
  },
  getOrgGuid: (state) => {
    return state.orgGuid
  },
  getOrgId: (state) => {
    return state.orgId
  },
  getOrgType: (state) => {
    return state.orgType
  },
  getSettings: (state) => {
    return state.settings
  },
  getOrgIcon: (state) => {
    return state.settings.orgIcon
  },
  getOrgAppIcon: (state) => {
    return state.settings.orgAppIcon
  },
  getOrgName: (state) => {
    return state.settings.name
  },
  getServicerImageUrl: (state) => {
    return state.settings.servicerImageUrl
  },
  getServicerInitials: (state) => {
    return state.settings.servicerInitials
  },
  getPartnerImageUrl: (state) => {
    return state.settings.partnerImageUrl
  },
  getPartnerInitials: (state) => {
    return state.settings.partnerInitials
  },
  getLandingPageTitle: (state) => {
    return state.settings.landingPageTitle
  },
  getSubmissionPageBodyText: (state) => {
    return state.settings.submissionPageBodyText
  },
  getAnswer: (state) => (questionKey) => {
    return state.answers[questionKey]
  },
  getCurrentQuestionIndex: (state) => {
    return state.currentQuestionIndex
  },
  isInLeadGenForm: (state) => {
    return state.leadGenQuestions && state.leadGenQuestions.length > 0 && !state.formSubmitted
  },
  isFormSubmitted: (state) => {
    return state.formSubmitted
  },
  getSac: (state) => {
    return state.sac
  },
  getLeadId: (state) => {
    return state.leadId
  },
  getPreviewForm: (state) => {
    return state.previewForm
  },
  getPreviewQuestion: (state) => {
    return state.previewQuestion
  },
  getShowLandingPage: (state) => {
    return state.showLandingPage
  },
  showBackButton: (state) => {
    return state.showLandingPage || state.currentQuestionIndex > 0
  }
}
